import readySound from '../assets/sounds/ready.mp3';
import startSound from '../assets/sounds/start_end.mp3';
import warningSound from '../assets/sounds/ten.mp3';

// export const SOUNDS = [
//     {
//         sound: 'http://esencoder.com/resources/sounds/ready.mp3'
//     },
//     {
//         sound: 'http://esencoder.com/resources/sounds/start_end.mp3'
//     },
//     {
//         sound: 'http://esencoder.com/resources/sounds/ten.mp3'
//     },
// ]
export const SOUNDS = [
    {
        sound: readySound
    },
    {
        sound: startSound
    },
    {
        sound: warningSound
    },
]

export const MESSAGE = {
    box: 'BOX',
    pause: 'PAUSA',
    ready: 'PREP\u00C1RATE',
    rest: 'DESCANSO'
}

export const DEFAULT_VALUES = {
    rounds: "12",
    roundTime: "03:00",
    restTime: "01:00",
    ready: "00:10",
    roundEndWarnign: "00:10",
}

export const REGEX = {
    digit: /^\d+$/,
    time: /^(?:([0-5]?\d):)?([0-5]?\d)$/,
    minute: /^([0-5]?\d):/
}
///^(?:([01]?\d|2[0-3]):([0-5]?\d):)?([0-5]?\d)$/
// ^                   #  Start of string
// (?:                 #  Try to match
// ([01]?\d|2[0-3]):   #  HH:
// ([0-5]?\d):         #  MM:
// )?                  #  (entire group)
// ([0-5]?\d)          #  SS
// $                   #  End of string
export const validate = {
    isDigit: (value: string): boolean => {
        return value.match(REGEX.digit) ? true : false;
    },
    isMinute: (value: string): boolean => {
        return value.match(REGEX.minute) ? true : false;
    },
    isTime: (value: string): boolean => {
        return value.match(REGEX.time) ? true : false;
    }
}

export const isDigit = (value: string): boolean => {
    return value.match(REGEX.digit) ? true : false;
}